// src/components/common_components/OptionSelector.js

import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import renderIconOption from './renderIconOption';

// renderIconOption function used in this component accepts the following parameters:
// iconName: the name of the icon to be rendered
// tooltipText: the text to be displayed as a tooltip
// selectedOption: the currently selected option
// optionValue: the value of the option
// setSelectedOption: a function to update the selected option

const OptionSelector = ({ options, initialOption }) => {
    const [selectedOption, setSelectedOption] = useState(initialOption);

    return (
        <Container fluid className="mt-0 p-0" style={{ height: '100vh', width: '100%', marginTop: '-20px' }}>
            <Row>
                <Col style={{ width: '65px', textAlign: 'center', flex: 'none' }}>
                    {options.map(option => (
                        renderIconOption(option.icon, option.label, selectedOption, option.value, setSelectedOption)
                    ))}
                </Col>
                <Col style={{ flex: "1", paddingTop: '7px' }}>
                    {options.map(option => (
                        selectedOption === option.value && <option.component key={option.value} />
                    ))}
                </Col>
            </Row>
        </Container>
    );
};

export default OptionSelector;
